module.exports = __webpack_public_path__ + "img/MI_AT_3_capa_LA_mercado_2021_PF_0001.7c76d81a.png";